var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"icon-cart",staticStyle:{"font-size":"2rem"}}),_c('p',{staticClass:"mt-2"},[_c('span',{staticClass:"font-500"},[_vm._v(_vm._s(_vm.title || 'Your cart is empty.'))]),_c('br'),_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }